import React from 'react'
import PropTypes from 'prop-types'
import { Grid2, Icon, IconButton, Tooltip } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import { darkBlue } from 'utils/constants/ColorTheme'
import { ALIGN } from 'components/datatable/NewTable'
import { isEqual, partition } from 'lodash'

const IconMenu = ({ link }) => {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { href, name, icons, external } = link
    // verify if each part of the href is equal to each part on the actual url
    const hrefSegments = href.split('/')
    const pathSegments = pathname.split('/').slice(0, hrefSegments.length)
    const isSelected = !external && isEqual(pathSegments, hrefSegments)

    return (
        <Tooltip title={name} placement='right'>
            <Grid2
                key={href}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '40px',
                    padding: '0 10px',
                    cursor: 'pointer',
                    borderRadius: '10px',
                    backgroundColor: isSelected ? 'lightgrey' : 'white',
                    '&:hover': { backgroundColor: 'lightgrey' },
                }}
                onClick={() => navigate(href)}
            >
                <IconButton
                    sx={{
                        fontSize: '24px',
                        padding: '6px',
                        '&:hover': { backgroundColor: 'transparent' },
                    }}
                    data-cy={link['data-cy']}
                >
                    <Icon fontSize='inherit' sx={{ color: isSelected ? darkBlue : '#777' }}>{icons}</Icon>
                </IconButton>
            </Grid2>
        </Tooltip>
    )
}

IconMenu.propTypes = {
    link: PropTypes.shape({
        'data-cy': PropTypes.string,
        id: PropTypes.string,
        href: PropTypes.string.isRequired,
        name: PropTypes.string,
        position: PropTypes.oneOf([ALIGN.TOP, ALIGN.BOTTOM]),
        icons: PropTypes.string.isRequired,
        external: PropTypes.bool,
        tooltip: PropTypes.bool,
    }).isRequired,
}

const FixedSlideNav = ({ links = [] }) => {
    const [linksTop, linksBottom] = partition(links, l => l.position !== ALIGN.BOTTOM)

    return (
        <div
            style={{
                position: 'fixed',
                top: '64px',
                width: '65px',
                height: 'calc(100vh - 64px)',
                padding: '5px 0 20px 0',
                backgroundColor: '#fff',
                overflowY: 'auto',
                boxShadow: '0 16px 24px 2px rgba(0,0,0,0.14),0 6px 30px 5px rgba(0,0,0,0.12),0 8px 10px -5px rgba(0,0,0,0.3)',
            }}
        >
            <Grid2 container spacing={0.8} direction='column' justifyContent='space-between' alignItems='center' sx={{ height: '100%' }}>
                <Grid2 container direction='column'>
                    {linksTop.map(link => <IconMenu key={link.href} link={link} />)}
                </Grid2>
                <Grid2 container direction='column'>
                    {linksBottom.map(link => <IconMenu key={link.href} link={link} />)}
                </Grid2>
            </Grid2>
        </div>
    )
}

FixedSlideNav.propTypes = {
    links: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        href: PropTypes.string.isRequired,
        name: PropTypes.string,
        position: PropTypes.oneOf([ALIGN.TOP, ALIGN.BOTTOM]),
        icons: PropTypes.string.isRequired,
        external: PropTypes.bool,
        tooltip: PropTypes.bool,
    })).isRequired,
}

export default FixedSlideNav
